<script>
    import R, {LOADER} from "../lib/requests";
    import {OBJECTS} from "../lib/constants";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import clocking from "../stores/clocking";
    import charges from "../stores/charges";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import Icon from "../components/Icon.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import ChargeIcon from "../components/icons/ChargeIcon.svelte";

    export let task = null;
    export let groupId = null; // id of task group to charge or merge
    export let groupDate = null; // date of task group to merge

    let showMore = false;
    let disableCheck = false;
    let disableControls = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            if (showMore) {
                event.preventDefault();
                event.stopPropagation();
                closeMore();
            }
        }
    }

    const onEdit = () => {
        if (disableControls) {
            return;
        }
        dispatch('edit', task);
    }

    const deleteTask = () => {
        const onSuccess = result => {
            Notifier.showMessage("Η εργασία διαγράφτηκε");
            dispatch('delete', task.id);
        }

        const onFailure = err => {
        };

        R.handle(R.task.delete, task.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onDelete = () => {
        closeMore();

        // if (task.id === 0) {
        //     dispatch('delete', task.id);
        //     return;
        // }

        Alert.delete("Διαγραφή εργασίας", `Να διαγραφεί η εργασία "${task.name}";`, () => {
            deleteTask(task.id);
        });
    }


    const onRestart = () => {
        dispatch('restart', task);
    }

    const onArchive = () => {

        const onSuccess = result => {
            Notifier.showMessage("Η εργασία αρχειοθετήθηκε");
            dispatch('archive', task.id);
        }

        const onFailure = err => {
        };

        Alert.confirm("Αρχειοθέτηση", `Να αρχειοθετηθεί η εργασία "${task.name}";`, () => {
            R.handle(R.task.archive, task.id, onSuccess, onFailure, LOADER.POPUP);
        });
    }


    const openMore = () => {
        if (!showMore) {
            showMore = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeMore = () => {
        if (showMore) {
            showMore = false;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    const onCreateCharge = () => {
        console.log(task);
        if (!task.charge_id) {
            charges.create(OBJECTS.TASK, task.id, {project: task.project}, closeCharge);
        } else {
            charges.edit(task.charge_id, closeCharge);
        }
    }

    const closeCharge = (param) => {
        if (param) {
            task.charge_id = param.id;
        }
    }

    const onToggle = () => {
        dispatch("toggle", task);
    }

    $: {
        disableCheck = (groupId > 0 && groupId != task.group_id) || task.charge_id;
        disableControls = groupId != null;
    }
</script>

{#if task}
    <div class="task">
        <div class="column name-project">

            <div class=" name">
                {#if groupId != null && (groupDate == null || groupDate === task.date)}
                    <Checkbox label="{ task.name }" bind:checked={ task.is_selected }
                              on:change={ onToggle }
                              disabled="{ disableCheck }"/>
                {:else}
                    <span class="is-link" on:click={ onEdit }>{ task.name }</span>
                {/if}
            </div>
            <div class="column project">
                {#if task.project}
                    <ColoredNameControl name="{ task.project.name }" color="{ task.project.color }" colorName/>
                {/if}
            </div>

            <div class="column tags">
                {#each task.tags as tag}
                    <div class="tag" style="color: #{ tag.color };">{ tag.name }</div>
                {/each}
            </div>
        </div>
        <div class="column price border-after">
            {#if task.price}
                {task.price}
            {/if}
        </div>
        <div class="column border-after px-0" class:blue-icon={ task.charge_id }
             class:text-gray={ !task.charge_id }>
            {#if task.price}
                <button class="btn btn-link" on:click={ onCreateCharge } disabled="{ disableControls }">
                    <ChargeIcon size="16" active="{ task.charge_id }"/>
                </button>
            {/if}
        </div>
        <div class="column times border-after">
            { task.startTime } - { task.endTime }
        </div>
        <div class="column duration">
            { task.durationTime }
        </div>
        <div class="column border-after">
            <button class="btn btn-default" on:click={ onRestart }
                    disabled="{ disableControls || $clocking.task.id > 0 }">
                <AppIcon icon="play"/>
            </button>
        </div>
        <div class="column more dropdown-container p-0">
            <button class="btn btn-icon" on:click="{ openMore }" disabled="{ disableControls }">
                <Icon name="more-vertical" size="18"/>
            </button>
            {#if showMore}
                <ul class="dropdown right" use:clickOutside on:click_outside="{ closeMore }">
                    <li class="dropdown-item d-flex align-items-center justify-content-between gap-2"
                        class:disabled={ !task.price } on:click={ onCreateCharge }>
                        Χρέωση
                        <span><ChargeIcon size="16" active="{ task.charge_id }"/></span>
                    </li>
                    <li class="dropdown-item d-flex align-items-center justify-content-between gap-2"
                        on:click="{ onDelete }">
                        Διαγραφή
                        <span><AppIcon icon="trash"/></span>
                    </li>
                    <li class="dropdown-item d-flex align-items-center justify-content-between gap-2"
                        on:click="{ onArchive }">
                        Αρχειοθέτηση
                        <span><AppIcon icon="archive"/></span>
                    </li>
                </ul>
            {/if}
        </div>
    </div>
{/if}


<style>
    .task {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: var(--default-border);
    }

    .task:last-child {
        border-bottom: none;
    }

    .task .column {
        display: flex;
        align-items: center;
        height: 50px;
        padding: 0 15px;
    }

    .task .name-project {
        width: 100%;
    }

    .task .name {
        min-width: 210px !important;
    }

    .task .project {
    }

    .task .tags {
        display: flex;
    }

    .task .tags .tag {
        white-space: nowrap;
        padding: 0 5px;
        margin-right: 5px;
        border: 1px solid #e4eaee;
        border-radius: 4px;
    }

    .task .tags .tag:last-child {
        margin-right: 0;
    }

    .task .times {
        width: 150px;
        justify-content: center;
    }

    .task .duration {
        width: 110px;
        font-weight: 500;
        justify-content: center;
        padding-right: 0;
    }

    .task .more {
        cursor: pointer;
    }

    .task .price {
        /*width: 90px;*/
        text-align: right;
    }

</style>